module.exports = __webpack_public_path__ + "assets/img/title.c67cadc6.png";